module.exports = __webpack_public_path__ + "static/img/cus_14_pre.c1be2762.jpg";